import React, { useState, useEffect } from "react";
import {
    Container,
    Typography,
    List,
    Modal,
    ListItem,
    ListItemText,
    Button,
    Box,
    Grid,
    Pagination,
    TextField,
    Paper,
} from "@mui/material";
import AddCommentModal from "../components/AddCommentModal";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

const Topic = () => {
    const { t } = useTranslation();
    const { idSlug } = useParams();
    const [id, slug] = idSlug.split("-");
    const [topic, setTopic] = useState(null);
    const [comments, setComments] = useState([]);
    const [filteredComments, setFilteredComments] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isAddCommentOpen, setIsAddCommentOpen] = useState(false);
    const [isUnauthorizedModalOpen, setIsUnauthorizedModalOpen] = useState(false);
    const [unauthorizedMessage, setUnauthorizedMessage] = useState("");
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    // Başlık ve yorumları getir
    const fetchTopicDetails = async (page = 1, search = "") => {
        try {
            console.log(id);
            
            const response = await api.get(`/api/forum/topics/${id}`, { 
                params: { page, limit: 10, search },
              });

            console.log(response.data);

            setTopic(response.data.topic); // Başlık detaylarını al
            setComments(response.data.comments); // Tüm yorumları al
            setTotalPages(response.data.totalPages); // Toplam sayfa sayısı
            setCurrentPage(response.data.currentPage); // Şu anki sayfa

            // Arama sonuçlarını ayarla
            if (search) {
                setFilteredComments(response.data.filteredComments || response.data.comments); // Filtrelenmiş yorumlar varsa ayarla
            } else {
                setFilteredComments([]);
            }
        } catch (error) {
            console.error("Error fetching topic details:", error);
        }
    };




    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            setIsLoggedIn(true);
        }
    }, []);

    // Arama işlemi
    const handleSearch = async (e) => {
        if (!isLoggedIn) {
            setUnauthorizedMessage(t('forum.unauthorizedSearch'));
            setIsUnauthorizedModalOpen(true);
            return;
        }

        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        fetchTopicDetails(1, term);
    };

    // Sayfa değiştirme
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        fetchTopicDetails(value, searchTerm); // Sayfa değişiminde mevcut arama terimini koru
    };

    const handleAddCommentClick = async () => {
        // Unauthorized mesajını temizle
        setUnauthorizedMessage("");

        const token = localStorage.getItem("token"); // Token'ı al

        // Token yoksa kullanıcıyı uyar
        if (!token) {
            setUnauthorizedMessage(t('forum.unauthorizedComment'));
            setIsUnauthorizedModalOpen(true);
            return; // Fonksiyonu burada sonlandır
        }

        try {
            // Token varsa geçerliliğini kontrol et
            const isValid = await validateToken();
            if (!isValid) {
                setUnauthorizedMessage(t('forum.sessionExpired'));
                setIsUnauthorizedModalOpen(true);
                return; // Fonksiyonu burada sonlandır
            }
        } catch (error) {
            console.error("Error validating token:", error);
            setUnauthorizedMessage(t('forum.sessionError'));
            setIsUnauthorizedModalOpen(true);
            return;
        }

        // Token geçerliyse yorum ekleme modalını aç
        setIsAddCommentOpen(true);
    };





    const handleCloseUnauthorizedModal = () => {
        setIsUnauthorizedModalOpen(false);
    };

    const validateToken = async () => {
        try {
            const response = await api.get("/api/auth/validate-token", {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            return response.data.valid; // Token geçerliyse true döner
        } catch (error) {
            console.error("Token validation error:", error);
            return false; // Token geçersizse false döner
        }
    };

    useEffect(() => {
        fetchTopicDetails(); // İlk yüklemede başlık ve yorumları getir
    }, [id]);

    return (
        <Container
    maxWidth="lg"
    style={{
        marginTop: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        padding: "20px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    }}
>
    {/* Forum Anasayfasına Dönüş Düğmesi */}
    <Box marginBottom="20px" textAlign="left">
        <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/forum")}
        >
            {t("forum.backToHome")}
        </Button>
    </Box>

    <Grid container spacing={4}>
        {/* Sol Bölüm: Başlık ve Yorumlar */}
        <Grid item xs={12} md={8}>
            {topic ? (
                <Box>
                    <Typography variant="h1" gutterBottom style={{ fontWeight: "bold", fontSize:"26px" }}>
                        {topic.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        gutterBottom
                        style={{ fontStyle: "italic", color: "#6B89D6" }}
                    >
                        {t("forum.by")}: {topic.author.name} | {t("forum.createdAt")}:{" "}
                        {new Date(topic.createdAt).toLocaleDateString()}
                    </Typography>
                    <Typography
                        variant="body1"
                        paragraph
                        style={{ marginTop: "20px", marginBottom: "40px" }}
                        dangerouslySetInnerHTML={{ __html: topic.content }} // HTML içeriği göster
                    ></Typography>

                    <Typography
                        variant="h5"
                        style={{ fontWeight: "bold", marginBottom: "20px" }}
                    >
                        {t("forum.comments")}
                    </Typography>
                    <List>
                        {comments.map((comment) => (
                            <ListItem
                                key={comment.id}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    padding: "10px 0",
                                    borderBottom: "1px solid #f0f0f0",
                                }}
                            >
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "bold", marginBottom: "5px" }}
                                >
                                    {t("forum.by")}: {comment.author.name}
                                </Typography>
                                <Typography variant="body2" style={{ color: "gray" }}>
                                    {new Date(comment.createdAt).toLocaleString()}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    style={{ lineHeight: "1.6" }}
                                    dangerouslySetInnerHTML={{ __html: comment.content }} // HTML içeriği göster
                                ></Typography>
                            </ListItem>
                        ))}
                    </List>

                    {/* Pagination */}
                    <Box display="flex" justifyContent="center" marginTop="20px">
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </Box>
                </Box>
            ) : (
                <Typography variant="h6">{t("forum.loading")}</Typography>
            )}

            <Button
                variant="contained"
                color="primary"
                onClick={handleAddCommentClick}
                style={{ marginTop: "20px" }}
            >
                {t("forum.addComment")}
            </Button>

            {/* Yorum Ekleme Modalı */}
            <AddCommentModal
                open={isAddCommentOpen}
                onClose={() => setIsAddCommentOpen(false)}
                topicId={id}
                refreshComments={() => fetchTopicDetails(currentPage, searchTerm)}
            />
        </Grid>

        {/* Sağ Bölüm: Arama Alanı */}
        <Grid item xs={12} md={4}>
            <Paper
                style={{
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
            >
                <Typography
                    variant="h6"
                    style={{ marginBottom: "20px", fontWeight: "bold" }}
                >
                    {t("forum.searchComments")}
                </Typography>
                <TextField
                    fullWidth
                    placeholder={t("forum.searchPlaceholder")}
                    variant="outlined"
                    value={searchTerm}
                    onChange={handleSearch}
                    disabled={!isLoggedIn} // Giriş yapmamışsa arama kutusunu pasif yap
                    style={{ marginBottom: "20px" }}
                />
                {!isLoggedIn && (
                    <Typography
                        variant="body2"
                        style={{
                            fontStyle: "italic",
                            color: "gray",
                            marginBottom: "10px",
                        }}
                    >
                        {t("forum.loginToSearch")}
                    </Typography>
                )}
                <Typography
                    variant="body1"
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                    {t("forum.searchResults")}
                </Typography>
                <List>
                    {filteredComments.map((comment) => (
                        <ListItem key={comment.id}>
                            <ListItemText
                                primary={comment.content}
                                secondary={`${t("forum.by")}: ${comment.author.name}`}
                            />
                        </ListItem>
                    ))}
                </List>
            </Paper>
        </Grid>
    </Grid>

    {/* Unauthorized Modal */}
    <Modal
        open={isUnauthorizedModalOpen}
        onClose={handleCloseUnauthorizedModal}
        aria-labelledby="unauthorized-modal-title"
        aria-describedby="unauthorized-modal-description"
    >
        <Paper
            style={{
                width: "400px",
                margin: "auto",
                marginTop: "20vh",
                padding: "20px",
                textAlign: "center",
                borderRadius: "10px",
            }}
        >
            <Typography
                id="unauthorized-modal-title"
                variant="h6"
                style={{ marginBottom: "20px", fontWeight: "bold", color: "#d32f2f" }}
            >
                {t("forum.loginRequired")}
            </Typography>

            <Typography id="unauthorized-modal-description" style={{ marginBottom: "20px" }}>
                {unauthorizedMessage}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/login")}
                style={{ marginRight: "10px" }}
            >
                {t("forum.login")}
            </Button>
            <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/register")}
            >
                {t("forum.signup")}
            </Button>
        </Paper>
    </Modal>
</Container>

    );
};

export default Topic;
